// extracted by mini-css-extract-plugin
export default {"container":"styles_container__JYQfz","main":"styles_main__XignG","title":"styles_title__UEnHy","modalInput":"styles_modalInput__UM14X","modalBtn":"styles_modalBtn__7X4Vi"};